export const additionalStepsArray = ['/verifyEmail'];
export const marketNoCommsPage = ['TR'];
export const registerFlowPathnames = [
  '/register',
  '/verifyEmail',
  '/warmup',
  '/comms',
  '/vehiclepreferences',
  '/aboutcomms',
  '/marketingcomms',
];
